import React from 'react';
import { AppLayout } from './components/AppLayout';
import { Overview } from './pages/Overview';
import { PaymentRequests } from './pages/PaymentRequests';
import { Settings } from './pages/Settings';
import { VirtualTerminal } from './pages/VirtualTerminal';
import { PhysicalTerminals } from './pages/PhysicalTerminals';
import { SoftPosTerminals } from './pages/SoftPosTerminals';
import { Connect } from './pages/Connect';
import { Tutorials } from './pages/Tutorials';
import { Orders } from './pages/Orders';
import { Shops } from './pages/Shops';
import { ShopDetails } from './pages/ShopDetails';
export function App() {
  // Determine which component to render based on the path
  const path = window.location.pathname;
  let content;
  if (path === '/payment-requests') {
    content = <PaymentRequests data-id="element-0" />;
  } else if (path === '/settings') {
    content = <Settings data-id="element-1" />;
  } else if (path === '/virtual-terminal') {
    content = <VirtualTerminal data-id="element-2" />;
  } else if (path === '/physical-terminals') {
    content = <PhysicalTerminals data-id="element-3" />;
  } else if (path === '/softpos-terminals') {
    content = <SoftPosTerminals data-id="element-4" />;
  } else if (path === '/connect') {
    content = <Connect data-id="element-5" />;
  } else if (path === '/tutorials') {
    content = <Tutorials data-id="element-6" />;
  } else if (path === '/orders') {
    content = <Orders data-id="element-7" />;
  } else if (path === '/shops') {
    content = <Shops data-id="element-8" />;
  } else if (path === '/shop-details') {
    content = <ShopDetails data-id="element-9" />;
  } else {
    content = <Overview data-id="element-10" />;
  }
  return <AppLayout data-id="element-11">{content}</AppLayout>;
}